@if (newsBannerSlide.imageUrl) {
  <div
    (click)="onCardClick()"
    class="image flex-c"
    [style]="{
      'background-image': 'url(' + newsBannerSlide.imageUrl + ')',
    }"
    [class.cursor-pointer]="newsBannerSlide.link || !isDesktop">
    @if (showButtons) {
      <!-- Buttons in top right corner -->
      <div class="carousel-buttons">
        <button
          type="button"
          class="inwi-text-button-medium-secondary"
          (click)="onDeleteClick(newsBannerSlide)">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-trash-can"></i>
            </div>
            <div class="button-text">Löschen</div>
          </div>
        </button>
        <button
          type="button"
          class="inwi-text-button-medium-secondary"
          (click)="onEditClick(newsBannerSlide)">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-pen"></i>
            </div>
            <div class="button-text">Bearbeiten</div>
          </div>
        </button>
      </div>
    }
    <div class="image-text">
      <div class="image-title" [title]="newsBannerSlide.title">
        {{ newsBannerSlide.title }}
      </div>
      <div
        id="mobile-image-text"
        class="image-details"
        [title]="newsBannerSlide.teaserText"
        [innerHtml]="newsBannerSlide.teaserText"></div>
      @if (isDesktop) {
        <div
          id="desktop-image-text"
          class="image-details"
          [title]="newsBannerSlide.subtitle + ' ' + newsBannerSlide.description"
          [innerHtml]="
            newsBannerSlide.subtitle
              ? '<strong>' +
                newsBannerSlide.subtitle +
                '</strong> ' +
                newsBannerSlide.description
              : newsBannerSlide.description
          "></div>
      }
    </div>
  </div>
} @else {
  <app-hero-card-placeholder
    (click)="onCardClick()"
    class="hero-card-placeholder"
    [class.cursor-pointer]="newsBannerSlide.link"
    [colorHead]="newsBannerSlide.color0"
    [colorShapes]="newsBannerSlide.color70"
    [backgroundColor]="newsBannerSlide.color80">
    @if (showButtons) {
      <!-- Buttons in top right corner -->
      <div class="carousel-buttons">
        <button
          type="button"
          class="inwi-text-button-medium-secondary"
          (click)="onDeleteClick(newsBannerSlide)">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-trash-can"></i>
            </div>
            <div class="button-text">Löschen</div>
          </div>
        </button>
        <button
          type="button"
          class="inwi-text-button-medium-secondary"
          (click)="onEditClick(newsBannerSlide)">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-pen"></i>
            </div>
            <div class="button-text">Bearbeiten</div>
          </div>
        </button>
      </div>
    }
    <div class="image-text">
      <div class="image-title" [title]="newsBannerSlide.title">
        {{ newsBannerSlide.title }}
      </div>
      <div
        id="mobile-image-text"
        class="image-details"
        [title]="newsBannerSlide.teaserText"
        [innerHtml]="newsBannerSlide.teaserText"></div>
      <div
        id="desktop-image-text"
        class="image-details"
        [title]="newsBannerSlide.subtitle + ' ' + newsBannerSlide.description"
        [innerHtml]="
          newsBannerSlide.subtitle
            ? '<strong>' +
              newsBannerSlide.subtitle +
              '</strong> ' +
              newsBannerSlide.description
            : newsBannerSlide.description
        "></div></div
  ></app-hero-card-placeholder>
}
